import { Data2, useDataTypesHooks } from "../../../features/data-types"
import { TableName } from "../../../tables/types/types"
import { PreparationStatus } from "../../common"
import { useRoadmapActions } from "../actions/roadmapActions"
import { useRoadmapBuilders } from "../builders/roadmapBuilders"
import { useRoadmapLoaders } from "../loaders/roadmapLoaders"

export const useRoadmapService = () => {
    const { generateCode } = useDataTypesHooks()

    const roadmapLoaders = useRoadmapLoaders()
    
    const { buildRoadmap, buildDeliveryRoadmap } = useRoadmapBuilders()
    
    const { saveRoadmap, saveDeliveryRoadmaps } = useRoadmapActions()

    const createRoadmap = async (
        roadmapData: Data2,
        shipmentsData: Data2[]
    ) => {
        const deliveryIds = shipmentsData.map(shipmentData => shipmentData.id! as string)
        const { loadDeliveriesRoadmapsLinks } = roadmapLoaders()
        const loadedDeliveryRoadmaps = await loadDeliveriesRoadmapsLinks(deliveryIds, true)

        if (loadedDeliveryRoadmaps.length === 0) {
            const code = await generateCode(TableName.ROADMAPS)
            
            const roadmap = buildRoadmap({
                ...roadmapData,
                code
            })
            const savedRoadmap = await saveRoadmap(roadmap)
            
            const deliveryRoadmaps = shipmentsData.map(shipmentData => buildDeliveryRoadmap({
                deliveryId: shipmentData.id,
                roadmapId: savedRoadmap.id,
                order: shipmentData.order
            }))
            await saveDeliveryRoadmaps(deliveryRoadmaps)
            
            return savedRoadmap
        }
    }

    const prepareTruck = async (roadmapId: string) => {
        const { loadRoadmap } = roadmapLoaders()
        const loadedRoadmap = await loadRoadmap(roadmapId)

        const roadmap = buildRoadmap({
            ...loadedRoadmap,
            preparationStatus: PreparationStatus.READY
        })
        return saveRoadmap(roadmap)
    }

    return {
        createRoadmap,
        prepareTruck
    }
}
